<template>
  <v-card class="px-5 pb-5" fluid>
    <v-card-title class="pl-2">
      Подробная информация домофонов с ненастроенной камерой
      <v-spacer></v-spacer>
    </v-card-title>
    <div class="mb-4">
      <v-text-field
        v-model="filterAddress"
        placeholder="Поиск по адресу"
        outlined
        dense
        hide-details
        style="max-width: 280px"
        prepend-inner-icon="mdi-rename-box-outline"
        class="input input-search pl-3 shrink mb-1"
      />
    </div>
    <v-card-text class="py-0 px-1">
      <v-data-table
        class="table"
        :headers="detailCheckCamerasJournal"
        :items="filteredTable"
        :footer-props="{
              'items-per-page-options': [10, 20, 50],
            }"
      >
        <template v-slot:item.address="{ item }">
          <router-link class="routerLink" :to="`/doorphones/${item.doorphone_id}`">
            {{ item.address }}
          </router-link>
        </template>
        <template v-slot:item.cameraHasSettings="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                v-bind="attrs"
                v-on="on"
                class="btn__icon pa-0"
                width="18"
                height="18"
                style="cursor: auto;"
              >
                <v-icon x-small :color="item.camera_has_settings === true ? 'green' : 'red'">
                  mdi-checkbox-blank-circle
                </v-icon>
              </v-btn>
            </template>
            <span v-if="item.camera_has_settings">Да</span>
            <span v-else>Нет</span>
          </v-tooltip>
        </template>
        <template v-slot:item.cameraHasChannel="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                v-bind="attrs"
                v-on="on"
                class="btn__icon pa-0"
                style="cursor: auto;"
                width="18"
                height="18"
              >
                <v-icon x-small :color="item.camera_has_channel === true ? 'green' : 'red'">
                  mdi-checkbox-blank-circle
                </v-icon>
              </v-btn>
            </template>
            <span v-if="item.camera_has_channel">Да</span>
            <span v-else>Нет</span>
          </v-tooltip>
        </template>
        <template v-slot:item.cameraHasEntity="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                v-bind="attrs"
                v-on="on"
                class="btn__icon pa-0"
                width="18"
                height="18"
                style="cursor: auto;"
              >
                <v-icon x-small :color="item.camera_has_entity === true ? 'green' : 'red'">
                  mdi-checkbox-blank-circle
                </v-icon>
              </v-btn>
            </template>
            <span v-if="item.camera_has_entity">Да</span>
            <span v-else>Нет</span>
          </v-tooltip>
        </template>
        <template v-slot:item.status="{ item }">
          <div>
            <v-icon x-small :color="item.sip_color">
              mdi-checkbox-blank-circle
            </v-icon>
            {{ item.sip_status }}
          </div>
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { detailCheckCamerasJournal } from '../consts';

export default {
  name: 'CheckCamerasNavy',
  props: {
    cameras: {
      type: Array,
      required: true,
    },
  },
  data () {
    return {
      detailCheckCamerasJournal,
      filterAddress: '',
    };
  },
  computed: {
    ...mapGetters({
    }),
    filteredTable () {
      let result = this.cameras;

      if (this.filterAddress) {
        result = result.filter(doorphone => {
          return doorphone.address.toString().toLowerCase().includes(this.filterAddress.toLowerCase());
        });
      }
      return result;
    },
  },
  methods: {
    ...mapActions({
    }),
  },
};
</script>

<style lang="scss" scoped>
.routerLink {
  text-decoration: none;
}

.v-application a {
  color: #434850;
}

a:hover.routerLink {
  text-decoration: underline;
}
</style>
